import React, { Component, createRef } from "react";
import Select from "react-select";
import withRouter from "../../../Utils/withRouter";
import Swal from "sweetalert2";
import axios from "axios";
import { ConfigContext } from "../../../Context/ConfigContext";
import { currentDateAndTime, genderOptions, titleOptions } from "../../../Constants/constants";


class PersonalDetailsView extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      profile_picture: null,
      selectedProfilePicture: null,
      selectedProfilePictureName: "",
      profileUrl: "",
      reporting_manager_id: "",
      company_employee_type_id: "",
      company_employee_category_id: "",
      blood_Group: "",
      From_date: "",
      To_date: "",
      employee_code: "",
      is_contract_employee: '""',
      Title: "",
      employee_gender: "",
      Date_of_birth: "",
      employee_joining_date: "",
      Designation: [],
      employee_verified_row: [],
      Grade: [],
      Department: [],
      Location: [],
      location_id: "",
      department_id: "",
      designation_id: "",
      grade_id: "",
      SelectLevels: "",
      LinkValidDays: "",
      employee_name: "",
      employee_email_address: "",
      employee_mobile_number: "",
      employee_address: "",
      employee_official_email: "",
      required_documents: [],
      required_letters: [],
      rows: [],
      letter_rows: [],
      employee_category_row: [],
      employee_type_row: [],
      permanent_Address: "",
      pinCode: "",
      reporting_Manager: "",
      enter_State: "",
      state_options: [],
      current_Address: "",
      errors: {},
      loadingSubmit: false,
      data:{},
    };
    this.TitleRef = React.createRef();
    this.employee_nameRef = React.createRef();
    //  this.employee_mobile_numberRef= React.createRef();
    this.employee_genderRef = React.createRef();
    this.employee_email_addressRef = React.createRef();
    this.Date_of_birthRef = React.createRef();
    this.pinCodeRef = React.createRef();
    this.employee_addressRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ loadingList: false,
      data: this.props.data
     }, (prevState) => {
      console.log("data PersonalDetailsView ===>>>>>", this.state.data)
      //   this.GetDesignationMasters();
      //   this.GetGradeMasters();
      //   this.GetDepartmentMasters();
      //   this.GetLocationMasters();
      //   this.getStateAndDesignation();
      // this.GetInfo();
      //   this.GetEmployeesVerifiedList();
      //   this.GetEmployeesTypeList();
      //   this.GetEmployeesCategoryList();
    });
  }

  autoScroll = () => {
    console.log("errors", this.state.errors);
    const errorsList = this.state.errors;
    // console.log("errorsList?.Title",errorsList?.Title);

    if (errorsList?.Title) {
      const element = this.TitleRef.current;
      // console.log("element",element);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
    if (errorsList?.employee_name) {
      const element = this.employee_nameRef.current;
      // console.log("element",element);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
    // if (errorsList?.employee_mobile_number) {
    //     const element = this.employee_mobile_numberRef.current;
    //     console.log("element",element);
    //     if (element) {
    //         element.scrollIntoView({ behavior: "smooth", block: "center" });
    //         element.focus();
    //     }
    // }
    if (errorsList?.employee_gender) {
      const element = this.employee_genderRef.current;
      // console.log("element",element);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
    if (errorsList?.employee_email_address) {
      const element = this.employee_email_addressRef.current;
      // console.log("element",element);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
    if (errorsList?.Date_of_birth) {
      const element = this.Date_of_birthRef.current;
      // console.log("element",element);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
    if (errorsList?.pinCode) {
      const element = this.pinCodeRef.current;
      // console.log("element",element);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
    if (errorsList?.employee_address) {
      const element = this.employee_addressRef.current;
      // console.log("element",element);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
  };

  GetInfo = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Home/EmployeeCollectedData`, {
        params: {
          guest_employee_id: "10",
          company_id: "3",
          guest_employee_mobile_number: "3456783456",
          date: currentDateAndTime(),
        },
        headers,
      })
      .then((response) => {
        const { employee_data, success } = response.data;
        if (success === true) {
          console.log("Personal Details - GetInfo", employee_data);
          this.setState({
            guest_employee_id: employee_data[0]?.guest_employee_id,
            // employee_code: employee_data[0]?.employee_code,
            profileUrl: employee_data[0]?.employee_profile_picture,
            employee_name: employee_data[0]?.employee_name,
            employee_mobile_number: employee_data[0]?.employee_mobile_number,
            is_contract_employee: employee_data[0]?.is_contract_employee,
            employee_email_address: employee_data[0]?.employee_email_address,
            employee_gender: employee_data[0]?.employee_gender,
            employee_joining_date: employee_data[0]?.employee_joining_date,
            designation_id: employee_data[0]?.designation_title,
            department_id: employee_data[0]?.department_title,
            grade_id: employee_data[0]?.grade_title,
            location_id: employee_data[0]?.location_title,
            employee_address: employee_data[0]?.employee_address,
            reporting_manager_id: employee_data[0]?.reporting_manager_name,
            employee_official_email: employee_data[0]?.employee_official_email,
            blood_Group: employee_data[0]?.blood_group,
            From_date: employee_data[0]?.employee_from_date,
            To_date: employee_data[0]?.employee_to_date,
            Date_of_birth: employee_data[0]?.date_of_birth,
            Title: employee_data[0]?.employee_title,
            company_employee_category_id:
              employee_data[0]?.company_employee_category,
            company_employee_type_id: employee_data[0]?.company_employee_type,
            permanent_Address: employee_data[0]?.employee_permanent_address,
            pinCode: employee_data[0]?.pin_code,
            enter_State: employee_data[0]?.state_title,
          });
        }
      });
  };

  GetEmployeesVerifiedList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetEmployeesVerifiedList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_verified_row: data.data.map((row) => ({
              value: row?.employee_id,
              label: `${row?.employee_code} ${row?.employee_name}`,
            })),
          }));
        }
      });
  };

  GetEmployeesTypeList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetEmployeeTypeList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_type_row: data.data.map((row) => ({
              value: row.company_employee_type_id,
              label: row.company_employee_type,
            })),
          }));
        }
      });
  };

  GetEmployeesCategoryList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetEmployeeCategoryList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_category_row: data.data.map((row) => ({
              value: row.company_employee_category_id,
              label: row.company_employee_category,
            })),
          }));
        }
      });
  };

  handleFileChange = (e) => {
    // const file = e.target.files[0];
    // this.setState({
    //   profile_picture: file,
    //   selectedProfilePictureName: file ? file.name : '',
    // },()=>{
    //     console.log(this.state.selectedProfilePictureName, this.state.profile_picture)
    // });

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          profile_picture: file,
          selectedProfilePicture: e.target.result, // Base64 image preview
          selectedProfilePictureName: file.name,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  removeProfilePicture = () => {
    this.setState({
      profile_picture: null,
      selectedProfilePicture: null,
      selectedProfilePictureName: "",
    });
  };

  GetDesignationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then((response) => {
      var data = response.data.data.designation;
      if (response.data.success === true) {
        this.setState((prevState) => ({
          Designation: data.map((row) => ({
            value: row.designation_id,
            label: row.designation_title,
          })),
        }));
      }
    });
  };

  GetGradeMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then((response) => {
      var data = response.data.data.grades;
      if (response.data.success === true) {
        this.setState((prevState) => ({
          Grade: data.map((row) => ({
            value: row.grade_id,
            label: row.grade_title,
          })),
        }));
      }
    });
  };

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then((response) => {
      var data = response.data.data.department;
      if (response.data.success === true) {
        this.setState((prevState) => ({
          Department: data.map((row) => ({
            value: row.department_id,
            label: row.department_title,
          })),
        }));
      }
    });
  };

  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then((response) => {
      var data = response.data.data.location;
      if (response.data.success === true) {
        this.setState((prevState) => ({
          Location: data.map((row) => ({
            value: row.location_id,
            label: row.location_title,
          })),
        }));
      }
    });
  };

  getStateAndDesignation = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Payrolls/GetStatesAndDesignation`, { headers })
      .then((response) => {
        const { success } = response.data;
        console.log(response?.data);
        if (success === true) {
          // let rows1 = response?.data?.response?.states.map((val) => {
          //   return { value: val?.state_id, label: val?.state_title }
          // });
          this.setState((prevState) => ({
            state_options: response?.data?.response?.states?.map((row) => ({
              value: row.state_id,
              label: row.state_title,
            })),
          }));
        }
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors }, () => {
        this.autoScroll();
      });
      return;
    }
    this.setState({ loadingSubmit: true });
    const { apiURL, apiHeaderFile } = this.context;
    const headers = apiHeaderFile;
    const employee_id = this.props.params.employee_id;

    // Create a new FormData object
    const formData = new FormData();

    // Append form data to the FormData object
    formData.append("guest_employee_id", employee_id);
    formData.append("blood_group", this.state.blood_Group);
    formData.append("reporting_manager_id", this.state.reporting_manager_id);
    formData.append("employee_from_date", this.state.From_date);
    formData.append("employee_from_to", this.state.To_date);
    formData.append("employee_title", this.state.Title);
    formData.append("employee_gender", this.state.employee_gender);
    formData.append("date_of_birth", this.state.Date_of_birth);
    formData.append("employee_joining_date", this.state.employee_joining_date);
    formData.append("designation_id", this.state.designation_id);
    formData.append("department_id", this.state.department_id);
    formData.append("grade_id", this.state.grade_id);
    formData.append("is_contract_employee", this.state.is_contract_employee);
    formData.append("location_id", this.state.location_id);
    formData.append("employee_name", this.state.employee_name);
    formData.append(
      "employee_email_address",
      this.state.employee_email_address
    );
    formData.append(
      "employee_official_email",
      this.state.employee_official_email
    );
    formData.append(
      "employee_mobile_number",
      this.state.employee_mobile_number
    );
    formData.append("employee_address", this.state.employee_address);
    formData.append(
      "employee_category",
      this.state.company_employee_category_id
    );
    formData.append("employee_type", this.state.company_employee_type_id);
    formData.append("employee_permanent_address", this.state.permanent_Address);
    formData.append("pin_code", this.state.pinCode);
    formData.append("employee_state", this.state.enter_State);
    formData.append("employee_profile_picture", this.state.profile_picture);

    axios
      .post(`${apiURL}Home/EmployeeCollectedData`, formData, { headers })
      .then((response) => {
        const { success } = response.data;
        if (success === true) {
          // this.setState({
          //   profile_picture: null,
          //   blood_Group: '',
          //   employee_Code: '',
          //   designation: '',
          //   company_employee_category_id: null,
          //   company_employee_type_id: null,
          //   permanent_Address: '',
          //   pinCode: '',
          //   employee_Name: '',
          //   date_Of_Birth: '',
          //   date_Of_Joining: '',
          //   email: '',
          //   mobile_Number: '',
          //   enter_State: '',
          //   current_Address: '',
          // });
          this.setState({ loadingList: false, loadingSubmit: false }, () => {
            this.GetInfo();
          });

          Swal.fire({
            title: `<strong>${
              response.data.success === true ? "Success" : "Failed"
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            showConfirmButton: true,
            allowOutsideClick: false,
          });
        } else {
          Swal.fire({
            title: `<strong>${
              response.data.success === true ? "Success" : "Failed"
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            showConfirmButton: true,
            allowOutsideClick: false,
          });

          this.setState({ loadingList: true, loadingSubmit: false }, () => {});
        }
      })
      .catch((error) => {
        // Handle any errors that occur during the request
        Swal.fire({
          title: <strong>Error</strong>,
          html: error,
          icon: "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      });
  };

  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handleRadioChange = (name, value) => {
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  validateForm = () => {
    const errors = {};
    if (!this.state.Title) {
      errors.Title = "Title is required";
      return errors;
    }
    if (!this.state.employee_gender) {
      errors.employee_gender = "GenderTitle is required";
      return errors;
    }
    if (!this.state.employee_name) {
      errors.employee_name = "Employee name is required";
      return errors;
    }
    // if (!this.state.employee_mobile_number){
    //     errors.employee_mobile_number = 'Employee mobile number is required';
    //     return errors;
    // }
    if (!this.state.employee_email_address) {
      errors.employee_email_address = "Employee email address is required";
      return errors;
    }
    // if (!this.state.employee_official_email){
    //     errors.employee_official_email = 'Employee email official is required';
    //     return errors;
    // }
    if (!this.state.Date_of_birth) {
      errors.Date_of_birth = "Date of birth is required";
      return errors;
    }
    // if (!this.state.employee_joining_date){
    //     errors.employee_joining_date = 'Employee joining date is required';
    //     return errors;
    // }
    // if (!this.state.reporting_manager_id){
    //     errors.reporting_manager_id = 'Reporting manager is required';
    //     return errors;
    // }
    // if (!this.state.location_id){
    //     errors.location_id = 'Location is required';
    //     return errors;
    // }
    // if (!this.state.department_id){
    //     errors.department_id = 'Department is required';
    //     return errors;
    // }
    // if (!this.state.designation_id){
    //     errors.designation_id = 'Designation is required';
    //     return errors;
    // }
    // if (!this.state.company_employee_type_id){
    //     errors.company_employee_type_id = 'Employee type is required';
    //     return errors;
    // }
    // if (!this.state.company_employee_category_id){
    //     errors.company_employee_category_id = 'Employee category is required';
    //     return errors;
    // }
    if (!this.state.pinCode) {
      errors.pinCode = "Pin code is required";
      return errors;
    }
    // if (!this.state.enter_State){
    //     errors.enter_State = 'State is required';
    //     return errors;
    // }
    if (!this.state.employee_address) {
      errors.employee_address = "Employee address is required";
      return errors;
    }

    // if (this.state.is_contract_employee === '1') {
    //   if (!this.state.From_date) errors.From_date = 'From date is required';
    //   if (!this.state.To_date) errors.To_date = 'To date is required';
    // }

    const mobileRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const pinCodeRegex = /^[0-9]{6}$/;

    // if (this.state.employee_mobile_number && !mobileRegex.test(this.state.employee_mobile_number)) {
    //   errors.employee_mobile_number = 'Invalid mobile number';
    //   return errors
    // }

    // if (this.state.employee_email_address && !emailRegex.test(this.state.employee_email_address)) {
    //   errors.employee_email_address = 'Invalid email address';
    //   return errors
    // }

    // if (this.state.employee_official_email && !emailRegex.test(this.state.employee_official_email)) {
    //   errors.employee_official_email = 'Invalid official email address';
    // return errors
    // }

    if (this.state.pinCode && !pinCodeRegex.test(this.state.pinCode)) {
      errors.pinCode = "Invalid pin code";
      return errors;
    }

    return errors;
  };

  render() {
    const { errors } = this.state;

    return (
      <div>
        <h5>
          Personal Details
        </h5>
        <div className="container mt-2">
          <form>
            <div className="row">
              <div className="col-md-6 mb-1">
                <label htmlFor="profile_pictureXX" className="form-label">
                  Profile Picture:
                </label>
                <br />
                <div className=" d-flex align-items-center gap-2">
                  {/* Display the profile picture */}
                  {this.state.data?.employee_profile_url ? (
                    <div
                      className="rounded-circle"
                      style={{
                        width: "55px",
                        height: "55px",
                        overflow: "hidden",
                        border: "1.5px solid #6464f4",
                        // marginRight: "10px",
                      }}
                    >
                      <img
                        src={
                          this.state.data?.employee_profile_url 
                        }
                        alt="Profile"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      <div className=" d-flex align-items-center gap-2">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#f2f2f2",
                            width: 50,
                            height: 50,
                            borderRadius: "10px",
                          }}
                        >
                          <i className="ri-user-3-line text-info" fontSize="24px"></i>
                          {/* <img
                            style={{ maxWidth: 150, width: "100%" }}
                            src="/img/placeholder-logo.png"
                            alt="Company Logo"
                          /> */}
                        </div>
                        <p className=" text-danger mb-0">Not Uploaded</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div ref={this.TitleRef} className="col-md-6 mb-3">
                <label htmlFor="Title" className="form-label">
                  Title:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <Select
                  id="Title"
                  name="Title"
                  isDisabled
                  value={
                    this.state.data?.employee_title 
                      ? titleOptions.find(
                          (option) => option.value === this.state.data?.employee_title
                        )
                      : null
                  }
                  // onChange={(selectedOption) =>
                  //   this.handleSelectChange("Title", selectedOption)
                  // }
                  options={titleOptions}
                  placeholder="Title"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: errors?.Title ? "red" : base.borderColor,
                      boxShadow: errors?.Title
                        ? "0 0 0 1px #f49595"
                        : state.isFocused
                        ? "0 0 0 1px blue"
                        : base.boxShadow,
                      "&:hover": {
                        borderColor: errors?.Title ? "red" : base.borderColor,
                      },
                    }),
                  }}
                />
              </div>

              <div ref={this.employee_nameRef} className="col-md-6 mb-3">
                <label htmlFor="employee_name" className="form-label">
                  Name:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  id="employee_name"
                  name="employee_name"
                  disabled
                  
                  value={this.state.data?.employee_name}
                  // onChange={this.handleInputChange}
                  className={`form-control ${
                    errors.employee_name ? "is-invalid" : ""
                  }`}
                  placeholder="Employee name"
                />
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="employee_mobile_number" className="form-label">
                  Contact No:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  type="number"
                  id="employee_mobile_number"
                  name="employee_mobile_number"
                  value={this.state.data?.employee_mobile_number}
                  disabled
                  //   onChange={this.handleInputChange}
                  className={`form-control`}
                  placeholder="Contact"
                />
              </div>

              <div ref={this.employee_genderRef} className="col-md-6 mb-3">
                <label htmlFor="employee_gender" className="form-label">
                  Gender:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <Select
                  id="employee_gender"
                  name="employee_gender"
                  value={
                    this.state.data?.employee_gender
                      ? genderOptions.find(
                          (option) =>
                            option.value === this.state.data?.employee_gender
                        )
                      : null
                  }
                  isDisabled
                  // onChange={(selectedOption) =>
                  //   this.handleSelectChange("employee_gender", selectedOption)
                  // }
                  options={genderOptions}
                  placeholder="Select gender"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: errors?.employee_gender
                        ? "red"
                        : base.borderColor,
                      boxShadow: errors?.employee_gender
                        ? "0 0 0 1px #f49595"
                        : state.isFocused
                        ? "0 0 0 1px blue"
                        : base.boxShadow,
                      "&:hover": {
                        borderColor: errors?.employee_gender
                          ? "red"
                          : base.borderColor,
                      },
                    }),
                  }}
                />
              </div>

              <div
                ref={this.employee_email_addressRef}
                className="col-md-6 mb-3"
              >
                <label htmlFor="employee_email_address" className="form-label">
                  Email Address:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  type="email"
                  id="employee_email_address"
                  name="employee_email_address"
                  value={this.state.data?.employee_email_address}
                  disabled
                  
                  // onChange={this.handleInputChange}
                  className={`form-control`}
                  placeholder="Employee Email Address"
                />
              </div>

              {/* <div className="col-md-6 mb-3">
                <label htmlFor="employee_official_email" className="form-label">Official Email:
                  <span
                    style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                    *
                  </span>
                </label>
                <input
                  type="email"
                  id="employee_official_email"
                  name="employee_official_email"
                  value={this.state.employee_official_email}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.employee_official_email ? 'is-invalid' : ''}`}
                  placeholder="Enter employee official email" />

                {errors.employee_official_email && <div className="invalid-feedback">{errors.employee_official_email}</div>}
              </div> */}
              {/* Date Of Birth */}
              <div ref={this.Date_of_birthRef} className="col-md-6 mb-3">
                <label htmlFor="Date_of_birth" className="form-label">
                  Date Of Birth:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  type="date"
                  id="Date_of_birth"
                  name="Date_of_birth"
                  value={this.state.data?.date_of_birth}
                  //   onChange={this.handleInputChange}
                  disabled
                  className={`form-control`}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="employee_joining_date" className="form-label">
                  Joining Date:
                  {/* <span
                    style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                    *
                  </span> */}
                </label>
                <input
                  type="date"
                  id="employee_joining_date"
                  name="employee_joining_date"
                  value={this.state.data?.employee_joining_date}
                  //   onChange={this.handleInputChange}
                  disabled
                  className={`form-control`}
                />
              </div>


              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="is_contract_employee" className="form-label">
                    Contract Employee:
                  </label>
                </div>
                <div className="form-check form-check-inline mt-2">
                  <input
                    type="radio"
                    id="is_contract_employee1"
                    name="is_contract_employee"
                    value="1"
                    checked={this.state.data?.is_contract_employee == "1"}
                    disabled
                    // onChange={() => this.handleRadioChange('is_contract_employee', '1')}
                    className={`form-check-input ${
                      errors.is_contract_employee ? "is-invalid" : ""
                    }`}
                  />
                  <label
                    htmlFor="is_contract_employee1"
                    className="form-check-label"
                  >
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="is_contract_employee0"
                    name="is_contract_employee"
                    value="0"
                    checked={this.state.data?.is_contract_employee == "0"}
                    disabled
                    // onChange={() => this.handleRadioChange('is_contract_employee', '0')}
                    className={`form-check-input ${
                      errors.is_contract_employee ? "is-invalid" : ""
                    }`}
                  />
                  <label
                    htmlFor="is_contract_employee0"
                    className="form-check-label"
                  >
                    No
                  </label>
                </div>
              </div>

              {this.state.data?.is_contract_employee == "1" && (
                <>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="From_date" className="form-label">
                      {" "}
                      From Date:
                      {/* <span
                      style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                      *
                    </span> */}
                    </label>
                    <input
                      type="date"
                      id="From_date"
                      name="From_date"
                      disabled
                      value={this.state.data?.employee_from_date}
                      // onChange={this.handleInputChange}
                      className={`form-control ${
                        errors.From_date ? "is-invalid" : ""
                      }`}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label htmlFor="To_date" className="form-label">
                      {" "}
                      To Date:
                      {/* <span
                      style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                      *
                    </span> */}
                    </label>
                    <input
                      type="date"
                      id="To_date"
                      name="To_date"
                      value={this.state.data?.employee_to_date}
                      disabled
                      // onChange={this.handleInputChange}
                      className={`form-control ${
                        errors.To_date ? "is-invalid" : ""
                      }`}
                    />
                  </div>
                </>
              )}

              <div className="col-md-6 mb-3">
                <label htmlFor="enter_State" className="form-label">
                  State:
                  {/* <span
                    style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                    *
                  </span> */}
                </label>
                <input
                  type="text"
                  id="enter_State"
                  name="enter_State"
                  value={this.state.data?.state_title}
                  disabled
                  className={`form-control`}
                />
                {/* <Select
                  options={this.state.state_options}
                  value={
                    this.state.enter_State
                      ? this.state.state_options.find(option => option.value === this.state.enter_State)
                      : null
                  }
                  isDisabled
                  onChange={(selectedOption) => this.handleSelectChange('enter_State', selectedOption)}
                  placeholder={`Select State`} /> */}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="Location" className="form-label">
                  Location:
                  {/* <span
                    style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                    *
                  </span> */}
                </label>
                <input
                  type="text"
                  id="location_id"
                  name="location_id"
                  value={this.state.data?.location_title}
                  disabled
                  className={`form-control`}
                />
                {/* <Select
                  value={this.state.location_id ? this.state.Location.find(option => option.value === this.state.location_id) : null}
                  options={this.state.Location}
                  isDisabled
                  onChange={(selectedOption) => this.handleSelectChange('location_id', selectedOption)}
                  placeholder={`Select location`} /> */}

              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="Department" className="form-label">
                  Department:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  id="department_id"
                  name="department_id"
                  value={this.state.data?.department_title}
                  disabled
                  className={`form-control`}
                />
                {/* <Select
                  value={this.state.department_id ? this.state.Department.find(option => option.value === this.state.department_id) : null}
                  options={this.state.Department}
                  isDisabled
                  onChange={(selectedOption) => this.handleSelectChange('department_id', selectedOption)}
                  placeholder={`Select department`} /> */}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="Designation" className="form-label">
                  Designation:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  id="designation_id"
                  name="designation_id"
                  value={this.state.data?.designation_title}
                  disabled
                  className={`form-control`}
                />
                {/* <Select
                  value={this.state.designation_id ? this.state.Designation.find(option => option.value === this.state.designation_id) : null}
                  options={this.state.Designation}
                  isDisabled
                  onChange={(selectedOption) => this.handleSelectChange('designation_id', selectedOption)}
                  placeholder={`Select designation`} /> */}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="Grade" className="form-label">
                  Grade:
                </label>
                <input
                  type="text"
                  id="grade_id"
                  name="grade_id"
                  value={this.state.data?.grade_title}
                  disabled
                  className={`form-control`}
                />
                {/* <Select
                  value={this.state.grade_id ? this.state.Grade.find(option => option.value === this.state.grade_id) : null}
                  options={this.state.Grade}
                  isDisabled
                  onChange={(selectedOption) => this.handleSelectChange('grade_id', selectedOption)}
                  placeholder={`Select grade`} /> */}
              </div>

              {/* <div className="col-md-6 mb-3">
                <label htmlFor="profile_pictureXX" className="form-label">Profile Picture:</label><br />
                <label htmlFor="profile_picture" className="btn btn-primary">
                  Choose File
                </label>
                <input
                  type="file"
                  id="profile_picture"
                  name="profile_picture"
                  onChange={this.handleFileChange}
                  className="form-control d-none"
                />
                {this.state.selectedProfilePictureName && (
                  <div className="mt-2 d-flex align-items-center">
                    <span>Selected file: {this.state.selectedProfilePictureName}</span>
                    <button
                      type="button"
                      className="btn-close ms-2"
                      aria-label="Close"
                      onClick={this.removeProfilePicture}>
                    </button>
                  </div>
                )}
              </div> */}

              <div className="col-md-6 mb-3">
                <label htmlFor="blood_Group" className="form-label">
                  Blood Group:
                </label>
                <input
                  type="text"
                  id="blood_group"
                  name="blood_group"
                  value={this.state?.data?.blood_group && this.state?.data?.blood_group !== "null" ? this.state?.data?.blood_group : "--"}
                  disabled
                  className={`form-control`}
                />
                {/* <Select
                  id="blood_Group"
                  name="blood_Group"
                  value={bloodGroupOptions.find(
                    (option) => option.value === this.state.data?.blood_group
                  )}
                  
                  isDisabled
                  onChange={(selectedOption) =>
                    this.handleSelectChange("blood_Group", selectedOption)
                  }
                  options={bloodGroupOptions}
                  placeholder="Blood group"
                /> */}
              </div>

              <div className="col-md-6 mb-3">
                <label
                  htmlFor="company_employee_type_id"
                  className="form-label"
                >
                  Employee Type:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  id="company_employee_type_id"
                  name="company_employee_type_id"
                  value={this.state.data?.company_employee_type}
                  disabled
                  className={`form-control`}
                />
                {/* <Select
                  id="company_employee_type_id"
                  name="company_employee_type_id"
                  value={this.state.employee_type_row.find(option => option.value == this.state.company_employee_type_id)}
                  isDisabled
                  onChange={(selectedOption) => this.handleSelectChange('company_employee_type_id', selectedOption)}
                  options={this.state.employee_type_row}
                  placeholder="Select employee type" /> */}
              </div>

              <div className="col-md-6 mb-3">
                <label
                  htmlFor="company_employee_category_id"
                  className="form-label"
                >
                  Employee Category:
                  {/* <span
                    style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                    *
                  </span> */}
                </label>
                <input
                  type="text"
                  id="company_employee_category_id"
                  name="company_employee_category_id"
                  value={this.state.data?.company_employee_category}
                  disabled
                  className={`form-control`}
                />
                {/* <Select
                  id="company_employee_category_id"
                  name="company_employee_category_id"
                  isDisabled
                  value={this.state.employee_category_row.find(option => option.value == this.state.company_employee_category_id)}
                  onChange={(selectedOption) => this.handleSelectChange('company_employee_category_id', selectedOption)}
                  options={this.state.employee_category_row}
                  placeholder="Select employee category" /> */}
              </div>
              <div ref={this.pinCodeRef} className="col-md-6 mb-3">
                <label htmlFor="pinCode" className="form-label">
                  Pin Code:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  id="pinCode"
                  name="pinCode"
                  value={this.state.data?.pin_code}
                  disabled
                  
                  // onChange={this.handleInputChange}
                  className={`form-control`}
                  placeholder="Enter pin code"
                />
              </div>
              <div ref={this.employee_addressRef} className="col-md-6 mb-3">
                <label htmlFor="employee_address" className="form-label">
                  Current Address:
                  <span
                    style={{
                      color: "blue",
                      borderRadius: "50%",
                      background: "#f0f8ff",
                      padding: "2px 6px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20px",
                      height: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    *
                  </span>
                </label>
                <textarea
                  id="employee_address"
                  name="employee_address"
                  value={this.state.data?.employee_address}
                  disabled
                  
                  // onChange={this.handleInputChange}
                  className={`form-control ${
                    errors.employee_address ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Employee Permanent Address"
                ></textarea>
                {errors.employee_address && (
                  <div className="invalid-feedback">
                    {errors.employee_address}
                  </div>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="permanent_Address" className="form-label">
                  Permanent Address:
                </label>
                <textarea
                  id="permanent_Address"
                  name="permanent_Address"
                  value={this.state.data?.employee_permanent_address}
                  disabled
                  
                  // onChange={this.handleInputChange}
                  className={`form-control`}
                  placeholder="Enter Employee Permanent Address"
                ></textarea>
              </div>
            </div>
          </form>
          {/* <div className="mt-4" style={{ float: "right" }}>
            {!this.state.loadingSubmit ? (
              <button
                type="button"
                onClick={this.handleSubmit}
                className="btn btn-success btn-label waves-effect right waves-light"
              >
                <i className="bx bx-save label-icon align-middle fs-16 ms-2" />{" "}
                Save
              </button>
            ) : (
              <button className="btn btn-success btn-load">
                <span className="d-flex align-items-center">
                  <span className="spinner-border flex-shrink-0" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </span>
                  <span className="flex-grow-1 ms-2">Saving...</span>
                </span>
              </button>
            )}
          </div> */}
        </div>
      </div>
    );
  }
}

export default withRouter(PersonalDetailsView);
